"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var CleanupIcon = function CleanupIcon(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, /*#__PURE__*/_react["default"].createElement("rect", {
    width: "24",
    height: "24",
    fill: "none"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M14,16.3c-3.6.8-4.7,1.9-5.5,5.5a.42.42,0,0,1-.8,0c-.8-3.6-1.9-4.7-5.5-5.5a.42.42,0,0,1,0-.8c3.6-.8,4.7-1.9,5.5-5.5a.42.42,0,0,1,.8,0c.8,3.6,1.9,4.7,5.5,5.5A.42.42,0,0,1,14,16.3Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.8,6.4c-2.4.6-3.2,1.3-3.7,3.7-.1.3-.5.3-.5,0C12,7.7,11.3,7,8.8,6.4a.28.28,0,0,1,0-.5c2.4-.6,3.2-1.3,3.7-3.7.1-.3.5-.3.5,0,.6,2.4,1.3,3.2,3.7,3.7C17.1,6,17.1,6.3,16.8,6.4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.5,12c-1.5.3-1.9.8-2.3,2.3a.15.15,0,1,1-.3,0c-.3-1.5-.8-1.9-2.3-2.3a.15.15,0,0,1,0-.3c1.5-.3,1.9-.8,2.3-2.3a.15.15,0,0,1,.3,0c.3,1.5.8,1.9,2.3,2.3C21.7,11.7,21.7,11.9,21.5,12Z"
  }));
};
var _default = exports["default"] = CleanupIcon;
//# sourceMappingURL=Cleanup.js.map